import { useState } from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import { Button } from "../Button";
import { Menu, MenuItem } from "@mui/material";
import { useIntl } from "react-intl";

const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const LocaleChanger = () => {
  const router = useRouter();
  const intl = useIntl();
  const { locales, locale } = router;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLocaleChange = (newLocale) => {
    router.push(router.asPath, undefined, { locale: newLocale });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!locales || !locale) {
    return null;
  }

  const getLanguageName = (locale: string) => {
    return intl.formatDisplayName(locale, { type: "language" });
  };

  return (
    <Container>
      <Button
        aria-controls="locale-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {getLanguageName(locale)}
      </Button>
      <Menu
        id="locale-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {locales.map((loc) => (
          <MenuItem
            key={loc}
            onClick={() => handleLocaleChange(loc)}
            style={{ fontWeight: loc === locale ? "bold" : "normal" }}
          >
            {getLanguageName(loc)}
          </MenuItem>
        ))}
      </Menu>
    </Container>
  );
};

export default LocaleChanger;
